import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import { Stack } from "@mui/material";

import React from "react";

const SIZE = 60;

export const DoneIcon = () => (
  <Stack
    justifyContent="center"
    alignItems="center"
    sx={{
      backgroundColor: "#00A507",
      borderRadius: "50%",
      height: SIZE,
      width: SIZE,
      minWidth: SIZE,
      minHeight: SIZE,
      flexShrink: 0,
    }}
  >
    <DoneRoundedIcon fontSize="large" sx={{ color: "#FFF" }} />
  </Stack>
);
